var React = require('react');

function OneDirectional (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43.7 1.1c-1.5-1.5-3.8-1.5-5.3 0 -1.5 1.5-1.5 3.8 0 5.3l19.8 19.8 -43.4 0c-2.1 0-3.7 1.7-3.7 3.8 0 2.1 1.7 3.8 3.8 3.8l43.4 0 -19.8 19.8c-1.5 1.5-1.5 3.8 0 5.3 1.5 1.5 3.8 1.5 5.3 0l26.2-26.2c0 0 0 0 0 0 0.7-0.7 1.1-1.6 1.1-2.6l0 0c0-0.5-0.1-1-0.3-1.4 -0.2-0.4-0.4-0.8-0.8-1.2 0 0 0 0 0 0m0 0l-26.2-26.2 26.2 26.2Z","key":0}),React.createElement("circle",{"cx":"11.3","cy":"30","r":"11.3","key":1})]);
}

OneDirectional.defaultProps = {"width":"71","height":"60","viewBox":"0 0 71 60","strokeLinejoin":"round"};

module.exports = OneDirectional;

OneDirectional.default = OneDirectional;
